import { render } from "./Checkout.vue?vue&type=template&id=dcdf84b8&scoped=true"
import script from "./Checkout.vue?vue&type=script&lang=js"
export * from "./Checkout.vue?vue&type=script&lang=js"

import "./Checkout.vue?vue&type=style&index=0&id=dcdf84b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcdf84b8"]])

export default __exports__